import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Container, Input } from '../../Components';
import axios from 'axios'

import { updateOrganizationPages, updateOrganizationPagesByID, updateUserOrganizationPageByID } from '../../Redux/features/authSlice';
import { useDispatch, useSelector } from 'react-redux';


export function PageSettingsGeneral() {

	const { page_id } = useParams();
	const navigate = useNavigate();
	const effectCalled = useRef(false)

	const [isLoading, setIsLoading] = useState(false)
	const [isLoadingStatuspageData, setIsLoadingStatuspageData] = useState(false)
	const { user , org } = useSelector((state) => state.auth)
	const dispatch = useDispatch()

	const [formData, setFormData] = useState({
		name: "",
		website_url: "",
		support_url: "",
		google_analytics_tracking: "",
	});
	const [formValidation, setFormValidation] = useState({
		name : "",
		 
	})


	useEffect(() => {

		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			
			await getStatuspageData();
		}
		fetchData();

		effectCalled.current = true ;
	  
	}, [])



	/**
	 * 
	 * @returns 
	 */
	const getStatuspageData = () => {

		return new Promise(async(resolve, reject) => { 

			setIsLoadingStatuspageData(true)
			
			//
			
			
			if (user && user.token && org && org?.id ) {
				
				let params = { }

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					setFormData( (prevState) => ({ 
						...prevState,
						name: data?.name,
						website_url: data?.website_url,
						support_url: data?.support_url,
						google_analytics_tracking: data?.google_analytics_tracking,
					}))

					 
					 

					setIsLoadingStatuspageData(false)
		
					resolve(data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					if(error?.response?.data?.error ==='NOT_FOUND'){
						navigate('/pages')
					}
					setIsLoadingStatuspageData(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}
				})
			}else{
				setIsLoadingStatuspageData(false)
			}

		})
	} 


	/**
	 * 
	 * @param {*} e 
	 * @returns 
	 */
	const onSubmit = async (e) => {
		e.preventDefault();

		return new Promise( async (resolve, reject) => { 
			
			setIsLoading(true)
			let validationName = '';
			validationName = (formData?.name === '') ? "Name can't be blank." : (formData?.name?.length < 5 ? 'Name must be a valid format ( at least 5 characters )' : '')
			setFormValidation((prevState) => ({
				...prevState,
				// name: (formData.name === '') ? "Name can't be blank." : '',
				name : validationName
			}))

			if( validationName !=='' ){
				toast.error("Please complete all required fields") 

				 
				setIsLoading(false)

				return 
			}

			
			
			//
			
			
			if (user && user.token && org && org?.id && formData?.id !==null ) {

				
				let params = { 
					name : formData?.name,
					website_url : formData?.website_url,
					support_url : formData?.support_url,
					google_analytics_tracking : formData?.google_analytics_tracking,
				}
				//console.log(params);

				const token = user?.token;


				await axios.put(`${process.env.REACT_APP_API_URL}/statuspages/${page_id}`, params , {
					headers : {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${token}`,//'JWT token...'
					}
				} )
				.then( res => res.data )
				.then( data => {

					setIsLoading(false)

					// Update the redux 
					updateReduxPageInfo(data);

					
					toast.success('Your page has been successfully updated') 
					 

					 
		
					resolve(data.data) 
		
				})
				.catch(error => {
					//console.log(error)
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							 
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
							reject(`Something went wrong. thank you try later.`)
						}
					}

					toast.error('Something went wrong, please try again later.') 
				})
			}else{
				setIsLoading(false)
				toast.error('Something went wrong, please try again later.') 
			}


		})

	}

	/**
	 * 
	 * @param {*} e 
	 */
	const onChange = (e) => {

		switch(e.target.name){
			case "name" : 
				setFormValidation((prevState) => ({
					...prevState,
					name : (e.target.value === '') ? "Name can't be blank." : (e.target.value.length < 5 ? 'Name must be a valid format ( at least 5 characters )' : '')
				}))
				
				break;
			 
			
		}

		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: (e.target.type ==='checkbox') ? e.target.checked :  e.target.value,
		}));
	};

	/**
	 * 
	 * @param {*} pageData 
	 * @returns 
	 */
     const updateReduxPageInfo = (data) => {

		// ! Update REDUX > ORG > STATUSPAGES [ ID ]
		dispatch(updateOrganizationPagesByID({
			statuspage_id : page_id ,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
				background_color : data?.background_color,
				header_text_color : data?.header_text_color,
			}
		}))

		 // ! Update the status page in REDUX > AUTH > USER > ORGANIZATIONS > STAUSPAGES
		 dispatch(updateUserOrganizationPageByID({
			organization_id : org?.id ,
			statuspage_id : page_id,
			data : {
				id : data?.id,
				name : data?.name,
				organization_legal_name : data?.organization_legal_name,
				website_url : data?.website_url,
				support_url : data?.support_url,
				created_at : data?.created_at,
				type : data?.type,
				custom_domain : data?.custom_domain,
				hosted_subdomain : data?.hosted_subdomain,
				logo : data?.logo,
				favicon : data?.favicon,
				is_active : data?.is_active,
				status : data?.status,
                background_color : data?.background_color,
				header_text_color : data?.header_text_color,
			}
		}))
	}

	return (
		<>
		<Helmet>
			<title>{`General - Page settings - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<form>
				{
					isLoadingStatuspageData === true 
					? 'Loading...'
					: (
						<>
				
					<Input
						label="Page name"
						placeholder=""
						name="name"
						onChange={onChange}
						value={formData?.name}
						required
						note="The public name of your website or service"
						error={formValidation?.name}
						
						/>
					
					<Input
						placeholder=""
						 
						prefix="https://"
						name="website_url"
						onChange={onChange}
						value={formData?.website_url}
						label="Company website URL"
						note="Clicking on the header of your status page will forward hereAdd the support link or email. This will be displayed as a Report an issue button in the header of your status page"
						required
						
						/>
				 
					<Input
						label="Support URL"
						note="Add the support link or email. This will be displayed as a Report an issue button in the header of your status page"
						placeholder=""
						 
						prefix="https://"
						name="support_url"
						onChange={onChange}
						value={formData?.support_url}
						required
						
						/>
					<Input
						label="Google Analytics tracking"
						note="If you'd like to use Google Analytics tracking on your page, paste the Tracking ID (aka. Property ID)here"
						placeholder="GA-XXXXXXXXX"
						name="google_analytics_tracking"
						onChange={onChange}
						value={formData?.google_analytics_tracking}
						required
						
						/>
                    <div className="field-group submit-fields-group fluid form_fixed_footer">
                        <Container className="flex-start">
                            <div   className='form_footer'   >
							    <Button  onClick={onSubmit}  loading={isLoading} >{'Save'}</Button>
                            </div>
                        </Container>
					</div>
					</>
					)
				}
			</form>
		</>
	)
}
